/** Shadow MarcacaoEvent id for CCC Prospeção leads (matches backend prospeccao_marcacao_id). */
export function prospeccaoMarcacaoId(leadId: string | number): string {
  return `PROSP-${Number(leadId)}`;
}

export function isValidMarcacaoId(id: string | null | undefined): id is string {
  if (typeof id !== 'string') return false;
  const trimmed = id.trim();
  return trimmed !== '' && trimmed !== 'undefined' && trimmed !== 'null';
}

/** Prefer explicit marcacao_id; fall back to PROSP-{leadId} for Prospeção leads. */
export function resolveProspeccaoMarcacaoId(
  leadId: string | number,
  marcacaoId?: string | null
): string {
  if (isValidMarcacaoId(marcacaoId)) return marcacaoId.trim();
  return prospeccaoMarcacaoId(leadId);
}
